import React from 'react'
import { NavLink } from 'react-router-dom'
import styles from "./Logo.module.css"
export default function Logo() {
  return (
    <div className={styles.logoContainer}><NavLink to='/'><img src='logo192.png'/></NavLink></div>
  )
}
